import React from "react";
import {
  Dialog,
  FlatButton,
  RaisedButton,
  TextField,
  Checkbox
} from "material-ui";
import Select from "react-select";
import Overlay from "./partials/overlays/base.jsx";

import Label from "./partials/label.jsx";
import TimezoneField from "./partials/timezone-field.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import config from "../config";

import connectToStores from "alt-utils/lib/connectToStores";
import GodActions from "../actions/GodActions";
import GodStore from "../stores/GodStore";

class GodAutoCreateUserModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {
        currency: "usd",
        fee_percent: 2,
        stripe_customer_id: ""
      }
    };

    this.onRequestClose = this.onRequestClose.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  static getStores() {
    return [GodStore];
  }

  static getPropsFromStores() {
    return GodStore.getState();
  }

  getStyles() {
    return {
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      }
    };
  }

  onRequestClose() {
    this.context.router.goBack();
  }

  onSave() {
    GodActions.autoCreate(this.state.values);
  }

  onChangeValue(id, value) {
    let { values } = this.state;
    values[id] = value;
    this.setState({ values });
  }

  render() {
    let styles = this.getStyles(),
      { autoCreating } = this.props;

    return (
      <div>
        <Dialog
          title={"Auto-create new organization & user"}
          openImmediately={true}
          hideTitleAndFooterBorders={true}
          onRequestClose={this.onRequestClose}
          actions={[
            <FlatButton
              label="Cancel"
              onTouchTap={this.onRequestClose}
              disabled={autoCreating}
            />,
            <FlatButton
              primary={true}
              label="Auto-create!"
              onTouchTap={this.onSave}
              disabled={autoCreating}
            />
          ]}
          titleStyle={styles.dialogTitle}
          actionsContainerStyle={styles.dialogActionsContainer}
          modal={true}
          open={true}
          autoDetectWindowHeight={false}
          autoScrollBodyContent={false}
          bodyStyle={{ overflowY: "visible" }}
          onRequestClose={this.onRequestClose}
        >
          {autoCreating ? (
            <WorkingIndicator centered />
          ) : (
            <div>
              <div>
                Automatically create a new organization with an admin user and a
                fake event bucket. The Intercom record associated with the email
                address you enter will automatically be updated as{" "}
                <strong>"organization approved"</strong>. The admin will{" "}
                <i>immediately</i> receive an email with login information.
              </div>
              <form autoComplete="off" style={{ width: 256, margin: "0 auto" }}>
                <div>
                  <TextField
                    value={this.state.values.organization}
                    floatingLabelText="Organization name"
                    floatingLabelFixed={true}
                    onChange={e =>
                      this.onChangeValue("organization", e.target.value)
                    }
                  />
                </div>
                <div>
                  <TextField
                    value={this.state.values.name}
                    floatingLabelText="Admin full name"
                    floatingLabelFixed={true}
                    onChange={e => this.onChangeValue("name", e.target.value)}
                  />
                </div>
                <div>
                  <TextField
                    value={this.state.values.email}
                    floatingLabelText="Admin email"
                    floatingLabelFixed={true}
                    onChange={e => this.onChangeValue("email", e.target.value)}
                  />
                </div>
                <div>
                  <TimezoneField
                    label="Example event bucket timezone"
                    value={this.state.values.timezone}
                    onChange={timezone =>
                      this.onChangeValue("timezone", timezone)
                    }
                  />
                </div>
                <div>
                  <Label>Currency</Label>
                  <Select
                    clearable={false}
                    value={this.state.values.currency}
                    options={config.fee.supported_currencies.map(k => ({
                      label: k.toUpperCase(),
                      value: k
                    }))}
                    onChange={e =>
                      this.onChangeValue("currency", e ? e.value : "")
                    }
                  />
                </div>
                <div>
                  <Label>Fee percent</Label>
                  <Select
                    clearable={false}
                    value={this.state.values.fee_percent}
                    options={[
                      { label: "2%", value: 2 },
                      { label: "4.5%", value: 4.5 }
                    ]}
                    onChange={e =>
                      this.onChangeValue("fee_percent", e ? e.value : "")
                    }
                  />
                </div>
                <div>
                  <TextField
                    value={this.state.values.stripe_customer_id}
                    floatingLabelText="Set Stripe customer ID (optional)"
                    placeholder="(will create new Stripe customer)"
                    floatingLabelFixed={true}
                    onChange={e =>
                      this.onChangeValue("stripe_customer_id", e.target.value)
                    }
                  />
                </div>
              </form>
            </div>
          )}
        </Dialog>
      </div>
    );
  }
}

export default connectToStores(GodAutoCreateUserModal);



// WEBPACK FOOTER //
// ./src/app/components/god-auto-create-user-modal.jsx